import { CHIconsType } from '@/components/UI/Icon/Icon'

export type ToastComponentType = React.FC<{ id: string }>
export type ToastOptionType = 'error' | 'warning' | 'success'

export type ToastType = {
  type: ToastOptionType
  id: string
  duration?: number
} & (
  | {
  title: string
  text: string
  body: null
}
  | { title: null; text: null; body: ToastComponentType }
  )

export const TOAST_ICONS: Record<string, CHIconsType> = {
  error: 'circleXmark',
  warning: 'triangleExclamation',
  success: 'circleCheck',
}
